import React from 'react';
import RemoveLastDirectoryPartOf from '../goBackButton';
import './settings.scss';

const Settings = () => {
    const rollno = localStorage.getItem('rollno');
    return (
        <div className="container">
            <div className="m-2" style={{ fontSize: '20px', display: 'flex' }}>
                <div className="mr-4">
                    <a
                        href={RemoveLastDirectoryPartOf(window.location.href)}
                        style={{ textDecoration: 'none' }}
                    >
                        <i className="fe fe-arrow-left" />
                    </a>
                </div>
                <div>Settings</div>
            </div>
            <div className="card">
                <div className="settings_sanjayaid settings_section">
                    <div className="settings_left">Sanjaya ID</div>
                    <div className="settings_right">{rollno}</div>
                </div>
                <div className="settings_about settings_section">
                    <div className="settings_left">Change Password</div>
                    <div className="settings_right settings_icon">
                        <a
                            style={{ textDecoration: 'none' }}
                            href="/sanjaya-web/changepassword"
                        >
                            <i className="fe fe-chevron-right"></i>
                        </a>
                    </div>
                </div>
                <div className="settings_about settings_section">
                    <div className="settings_left">About sanjaya</div>
                    <div className="settings_right settings_icon">
                        <a
                            style={{ textDecoration: 'none' }}
                            href="/sanjaya-web/settings/about"
                        >
                            <i className="fe fe-chevron-right"></i>
                        </a>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Settings;
